import React, { Fragment, ReactElement, ReactNode } from "react";

import { NavigationItemProps } from "./headerNavigation.types";

export const NavigationItem = ({
  children,
}: NavigationItemProps): ReactElement => {
  return <Fragment>{children}</Fragment>;
};

NavigationItem.displayName = "NavigationItem";

export interface NavigationProps {
  /** List of nav items to render on main navigation */
  children?: ReactNode;
}
const Navigation = ({ children }: NavigationProps): ReactElement => {
  return <Fragment>{children}</Fragment>;
};

Navigation.displayName = "Navigation";

Navigation.propTypes = {
  /** List of nav items to render on main and secondary navigation */
  children: (props: any, propName: any, componentName: any): any => {
    let error;
    const prop = props[propName];

    React.Children.forEach(prop, (child) => {
      if (child.type.name !== NavigationItem.name) {
        error = new Error(
          `${componentName} only accepts child nodes of type '<Header.NavItem>. Node '${child.type}' is not a valid type.`
        );
      }
    });
    return error;
  },
};

export { Navigation };
